import React, { useEffect, useState } from "react";

import Flag from "react-world-flags";
import { countries } from "country-list-json";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Container, Dropdown, Form, Image, Spinner } from "react-bootstrap";

import "bootstrap/dist/css/bootstrap.min.css";
import "./signin.css";

import backarrow from "../../assets/images/backarrow.jpg";
import logo2 from "../../assets/images/logo2.png";
import responsivebg from "../../assets/images/responsive-bg.png";

import { API_URL } from "../../api";
import { useCookies } from "../../hooks/useCookies";
import { useAppContext } from "../../Context/UseContext";
import IconButton from "../userflow/components/card/IconButton";
import SelectCountryModal from "../Utility/SelectCountryModal";
import * as authAction from "../../actions/auth";

export const SignIn = () => {
  const navigate = useNavigate();
  const { setCookie } = useCookies();
  const searchParams = useSearchParams();

  const [formattedPhoneNumber, setFormattedPhoneNumber] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("CA");
  const [selectedCountryInfo, setSelectedCountryInfo] = useState(() =>
    countries.find(country => country.code === "CA")
  );
  const [showModal, setShowModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isSendingOtp, setIsSendingOtp] = useState(false);

  const { phoneNumber, setPhoneNumber } = useAppContext()

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async position => {
          const { latitude, longitude } = position.coords;
          try {
            const response = await fetch(
              `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`
            );
            const data = await response.json();
            const country_code = data.countryCode || "CA";
            const countryInfo = countries.find(c => c.code === country_code);
            if (countryInfo) {
              setSelectedCountry(country_code);
              setSelectedCountryInfo(countryInfo);
            }
          } catch (err) {
            console.error("Geolocation API error:", err);
          }
        },
        error => console.error("Error getting location:", error)
      );
    }
  }, []); // Safe now, no dependency warning

  const handleCountrySelect = countryCode => {
    const countryInfo = countries.find(country => country.code === countryCode);
    if (countryInfo) {
      setSelectedCountry(countryCode);
      setSelectedCountryInfo(countryInfo);
      setPhoneNumber("");
      setFormattedPhoneNumber("");
      toggleModal();
    }
  };

  const toggleModal = () => setShowModal(prev => !prev);

  const handlePhoneNumberChange = e => {
    const rawValue = e.target.value.replace(/\D/g, "");
    let formattedValue = rawValue;
    if (rawValue?.length > 6) {
      formattedValue = `(${rawValue.slice(0, 3)}) ${rawValue.slice(
        3,
        6
      )}-${rawValue.slice(6, 10)}`;
    } else if (rawValue?.length > 3) {
      formattedValue = `(${rawValue.slice(0, 3)}) ${rawValue.slice(3)}`;
    } else if (rawValue?.length > 0) {
      formattedValue = `(${rawValue}`;
    }

    setFormattedPhoneNumber(formattedValue);
    setPhoneNumber(rawValue);
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (isSendingOtp) return;

    if (!phoneNumber) {
      setErrorMessage("*Phone is required");
      return;
    }

    setIsSendingOtp(true);
    setErrorMessage("");
    const completePhoneNumber = selectedCountryInfo.dial_code + phoneNumber;


    try {
     const response = await authAction.loginOTP({ phone: completePhoneNumber });
     if (response) {
        setCookie("phoneNumber", completePhoneNumber, 7);
        const nextRoute = searchParams[0].get("next") || "signinphoneotp";
        navigate(`/${nextRoute}`);
      } else {
        setErrorMessage("*" + (response.message || "Failed to send code"));
      }
    } catch (error) {
      console.error("OTP error:", error);
      setErrorMessage("An error occurred. Please try again later.");
    } finally {
      setIsSendingOtp(false);
    }
  };

  return (
    <div className="signupphone-container">
      <div className="signup-phone-bg">
        <Image className="responsive-bg" src={responsivebg} />
      </div>

      <Container className="signupphone-main">
        <Container className="signupphone-content">
          <Container className="logo-progressbar1">
            <Container className="logo-arrow1">
              <Image
                src={backarrow}
                className="backarrow"
                onClick={() => window.history.back()}
              />
              <Image
                src={logo2}
                alt="Logo"
                className="logo1"
                style={{ backgroundColor: "transparent" }}
              />
            </Container>
          </Container>

          <Container className="verify-phone-text">
            <IconButton type="phone" onClick={e => e.stopPropagation()} />
          </Container>

          <Container className="verify-phone-details">
            <Form onSubmit={handleSubmit} className="verify-phone-form">
              <Form.Group
                controlId="formPhoneNumber"
                className="verify-form-group"
              >
                <Form.Label className="num-verify-lable">
                  What's your phone number?
                </Form.Label>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <Dropdown>
                    <div
                      id="dropdown-basic"
                      onClick={() => setShowModal(true)}
                      className="flag-box"
                      style={{ borderColor: errorMessage ? "red" : "" }}
                    >
                      <Flag
                        code={selectedCountry}
                        className="flag"
                        style={{
                          width: "34px",
                          height: "25px",
                          marginRight: "10px",
                        }}
                      />
                      <span>{selectedCountryInfo.dial_code}</span>
                    </div>
                  </Dropdown>
                  <Form.Control
                    type="tel"
                    placeholder="(xxx)xxx-xxx"
                    value={formattedPhoneNumber}
                    onChange={handlePhoneNumberChange}
                    className={`num-verify-input ${errorMessage ? "error" : ""
                      }`}
                    style={{ flex: 1, marginLeft: "10px" }}
                  />
                </div>
                {errorMessage && (
                  <Form.Text
                    className="text-danger error-message"
                    style={{ marginTop: "5px" }}
                  >
                    {errorMessage}
                    {errorMessage.includes("Try signing up first") && (
                      <a href="./signup" className="signup-signin">
                        {" "}
                        here.
                      </a>
                    )}
                  </Form.Text>
                )}
              </Form.Group>
              <button
                type="submit"
                className="global-next-btn"
                disabled={isSendingOtp}
              >
                {isSendingOtp ? (
                  <Spinner animation="border" size="sm" role="status" />
                ) : (
                  "Next"
                )}
              </button>
            </Form>
          </Container>
        </Container>
      </Container>

      <SelectCountryModal
        show={showModal}
        onClose={() => setShowModal(false)}
        onSelectCountry={handleCountrySelect}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
      />
    </div>
  );
};
